<template>
  <span class="icon-filter-active">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 7.25L16 7.25C15.59 7.25 15.25 6.91 15.25 6.5C15.25 6.09 15.59 5.75 16 5.75L22 5.75C22.41 5.75 22.75 6.09 22.75 6.5C22.75 6.91 22.41 7.25 22 7.25Z" :fill="color"/>
      <path d="M6 7.25L2 7.25C1.59 7.25 1.25 6.91 1.25 6.5C1.25 6.09 1.59 5.75 2 5.75L6 5.75C6.41 5.75 6.75 6.09 6.75 6.5C6.75 6.91 6.41 7.25 6 7.25Z" :fill="color"/>
      <path d="M10 10.75C7.66 10.75 5.75 8.84 5.75 6.5C5.75 4.16 7.66 2.25 10 2.25C12.34 2.25 14.25 4.16 14.25 6.5C14.25 8.84 12.34 10.75 10 10.75ZM10 3.75C8.48 3.75 7.25 4.98 7.25 6.5C7.25 8.02 8.48 9.25 10 9.25C11.52 9.25 12.75 8.02 12.75 6.5C12.75 4.98 11.52 3.75 10 3.75Z" :fill="color"/>
      <path d="M22 18.25H18C17.59 18.25 17.25 17.91 17.25 17.5C17.25 17.09 17.59 16.75 18 16.75H22C22.41 16.75 22.75 17.09 22.75 17.5C22.75 17.91 22.41 18.25 22 18.25Z" :fill="color"/>
      <path d="M8 18.25H2C1.59 18.25 1.25 17.91 1.25 17.5C1.25 17.09 1.59 16.75 2 16.75H8C8.41 16.75 8.75 17.09 8.75 17.5C8.75 17.91 8.41 18.25 8 18.25Z" :fill="color"/>
      <path d="M14 21.75C11.66 21.75 9.75 19.84 9.75 17.5C9.75 15.16 11.66 13.25 14 13.25C16.34 13.25 18.25 15.16 18.25 17.5C18.25 19.84 16.34 21.75 14 21.75ZM14 14.75C12.48 14.75 11.25 15.98 11.25 17.5C11.25 19.02 12.48 20.25 14 20.25C15.52 20.25 16.75 19.02 16.75 17.5C16.75 15.98 15.52 14.75 14 14.75Z" :fill="color"/>
      <g clip-path="url(#clip0_18844_281989)">
        <rect x="9" y="9" width="16" height="16" rx="8" fill="white"/>
        <path d="M17 10.3333C13.32 10.3333 10.3334 13.3199 10.3334 16.9999C10.3334 20.6799 13.32 23.6666 17 23.6666C20.68 23.6666 23.6667 20.6799 23.6667 16.9999C23.6667 13.3199 20.68 10.3333 17 10.3333ZM15.1934 19.8599L12.8 17.4666C12.54 17.2066 12.54 16.7866 12.8 16.5266C13.06 16.2666 13.48 16.2666 13.74 16.5266L15.6667 18.4466L20.2534 13.8599C20.5134 13.5999 20.9334 13.5999 21.1934 13.8599C21.4534 14.1199 21.4534 14.5399 21.1934 14.7999L16.1334 19.8599C15.88 20.1199 15.4534 20.1199 15.1934 19.8599Z" :fill="color"/>
      </g>
      <rect x="8.5" y="8.5" width="17" height="17" rx="8.5" stroke="white"/>
      <defs>
        <clipPath id="clip0_18844_281989">
          <rect x="9" y="9" width="16" height="16" rx="8" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </span>
</template>


<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['secondary-500'] } },
  }
}
</script>
